import React from "react";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import {
  FormGroup,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  Button
} from "@mui/material";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { librarySearchFilters } from "../../constants";
import { isIframed } from "../../utils/iframe";

const useStyles = makeStyles(theme => ({
  checkboxGroup: {
    display: "flex",
    flexDirection: "row"
  },
  caption: {
    textTransform: "uppercase",
    paddingRight: theme.spacing(2)
  },
  filter: {
    padding: theme.spacing(1, 2.75, 1, 1),
    marginLeft: 0,
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0.5, 2.25, 0.5, 0.5)
    }
  }
}));

function SearchFilters(props) {
  const classes = useStyles();
  const theme = useTheme();
  const { onFiltersChange, filters, onClearAllClick } = props;
  const { t } = useTranslation();

  const handleFilterChange = (filter, filterValue) => event => {
    return onFiltersChange({
      ...filters,
      [filter]: { ...filterValue, checked: event.target.checked }
    });
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      justifyContent="space-between"
      mb={3}
    >
      <Box display="flex" alignItems="center" flexWrap="wrap">
        <Typography
          variant="caption"
          color="textSecondary"
          className={classes.caption}
          noWrap
        >
          {t("librarySearch.filterTitle")}:
        </Typography>
        <FormGroup className={classes.checkboxGroup}>
          {Object.keys(filters).map(filter => {
            return (
              <FormControlLabel
                style={{
                  background: filters[filter]
                    ? theme.palette.action.hover
                    : "none"
                }}
                className={classes.filter}
                key={filter}
                control={
                  <Checkbox
                    disabled={filters[filter].disabled}
                    color="primary"
                    checked={filters[filter].checked}
                    onChange={handleFilterChange(filter, filters[filter])}
                    value={filter}
                  />
                }
                label={
                  isIframed && filter == librarySearchFilters.myCourses
                    ? t(`searchFiltersIframed.${filter}`)
                    : t(`searchFilters.${filter}`)
                }
              />
            );
          })}
        </FormGroup>
      </Box>
      <Button color="primary" onClick={onClearAllClick}>
        {t("librarySearch.buttons.clearAllBtn")}
      </Button>
    </Box>
  );
}

export default SearchFilters;

SearchFilters.propTypes = {
  onFiltersChange: PropTypes.func,
  onClearAllClick: PropTypes.func,
  filters: PropTypes.object
};
